import lozad from 'lozad'

export default (_, inject) => {
  inject('lozad', lozad)
}
